
import { BaseResourceApi, type IResourceApiContext, type ApiOptions, type BaseRequestOptions } from './common'
import { createSchemaApiRequest, type ApiSchemaRequest, type ApiSchemaResponse } from './schema'
import { type Response } from '../datatypes'

export class ExperienceApi extends BaseResourceApi {
  options: ApiOptions
  constructor (ctx: IResourceApiContext, options?: ApiOptions) {
    super(ctx)
    this.options = {
      currentUser: false,
      ...options
    }
  }

  async getData (config: ApiSchemaRequest<'/experience/data/{id}', 'get'> & BaseRequestOptions & { static?: boolean }): Promise<ApiSchemaResponse<'/experience/data/{id}', 'get'>> {
    return await createSchemaApiRequest({
      path: '/experience/data/{id}',
      method: 'get',
      ctx: this.ctx,
      params: config.params,
      options: config,
      query: {
        ...config.query,
        ...(config.static === true ? { static: true } : {})
      }
    })
  }

  async getSetting (config: ApiSchemaRequest<'/experience/data/{id}/settings', 'get'> & BaseRequestOptions): Promise<ApiSchemaResponse<'/experience/data/{id}/settings', 'get'>> {
    return await createSchemaApiRequest({
      path: '/experience/data/{id}/settings',
      method: 'get',
      ctx: this.ctx,
      params: config.params,
      options: config
    })
  }

  async getCampaignActivations (config: ApiSchemaRequest<'/experience/{distributionId}/campaigns/activations', 'get'> & BaseRequestOptions): Promise<Response<CampaignActivationsResponse>> {
    return await createSchemaApiRequest({
      path: '/experience/{distributionId}/campaigns/activations',
      method: 'get',
      ctx: this.ctx,
      params: config.params,
      options: config
    }) as Response<CampaignActivationsResponse>
  }
}

interface CampaignActivationsResponse {
  items: object[]
  accessControlRules: object[]
  disableDistributionActivations: boolean
}
